import { Component, Input } from '@angular/core';
import { DashboardLocalizationService } from 'src/app/pages/profile-overview/components/dashboard/services/dashboard-localization.service';

@Component({
	selector: 'ahp-dashboard-memberships',
	templateUrl: './dashboard-memberships.component.html',
	styleUrls: ['./dashboard-memberships.component.scss'],
})
export class DashboardMembershipsComponent {
	/**
	 * the merchant locale suffix
	 */
	@Input() merchantLocaleSuffix: string;
	/**
	 * whether to display compulsory payment details
	 */
	@Input() displayCompulsoryDetails!: boolean;
	/**
	 * @param dashboardLocalization the dashboard localization service
	 */
	constructor(public dashboardLocalization: DashboardLocalizationService) {}
}
